import styled from 'styled-components';
import Input from '@widgets/shared/components/NumberInput/styles/control';
export const NumberInputWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.5rem;
  border: 0.1rem solid var(--border, $border);
  border-radius: var(--border-radius-sm);
  margin-bottom: 2rem;


  .h6 {
    margin-bottom: 0;
    font-weight: 600;
  }
`;
export const FieldWrapper = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 1 0;
  
  ${Input.Element} {
    font: var(--paragraph-font);
    font-weight: 600;
  }
`;
export const CardWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 2rem;
  
  .price-card {
    width: 50%;
  }
`;
export default {
    Wrapper: NumberInputWrapper,
};
